<template>
  <!--通知公告-->
  <div class="content Announcements">
    <div class="layui-fluid">
      <div class="layui-row">
        <div class="layui-col-md12">
          <!--面包屑-->
          <div class="layui-row">
            <div class="layui-col-md8">
              <span class="layui-breadcrumb" lay-separator=">">
                <a href>通知公告</a>
                <a href>消息配置</a>
              </span>
            </div>
          </div>
          <div class="layui-row" style="margin-top: 20px;">
            <div class="layui-col-md4">
              <form class="layui-form" action>
                <div class="layui-form-item">
                  <div class="layui-inline">
                    <label class="layui-form-label">消息类型:</label>
                    <div class="layui-input-block">
                      <select name="interest" lay-filter="aihao">
                        <option value>全部</option>
                        <option value="0">公告</option>
                      </select>                   
                    </div>                 
                  </div>
                </div>
              </form>
            </div>
             <div class="layui-col-md2">
              <button class="layui-btn" data-type="reload">搜索</button>
            </div>
            <div class="layui-col-md2">
              <button class="layui-btn" data-type="reload" @click="add_new">+新建消息</button>
            </div>
          </div>
          <div class="layui-row">
            <table class="layui-hide" id="test"></table>
            <script type="text/html" id="barDemo">
  <a class="layui-btn layui-btn-xs" lay-event="edit" style="color: #FFFFFF;">编辑</a>
  <a class="layui-btn layui-btn-danger layui-btn-xs" lay-event="del" style="color: #FFFFFF;">禁止</a>
  <a class="layui-btn layui-btn-danger layui-btn-xs" lay-event="del" style="color: #FFFFFF;">删除</a>
            </script>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Announcements",
  data() {
    return {
      msg: ""
    };
  },
  methods: {
    // 公共方法
    handlePublics() {
      let _this = this;
      this.$nextTick(() => {
        layui.use(["jquery", "element", "table", "form"], function() {
          var $ = layui.jquery;
          var element = layui.element;
          var form = layui.form;
          var table = layui.table;
          table.render({
            elem: "#test",
            // ,url:'/demo/table/user/'
            data: [
              { id: 1, username: "sex", sex: "女", city: "城市-0", sign: 1 },
              { id: 2, username: "sex", sex: "女", city: "城市-0", sign: 1 }
            ],
            cellMinWidth: 100, //全局定义常规单元格的最小宽度，layui 2.2.1 新增
            cols: [
              [
                { type: "checkbox" },
                { field: "id", title: "消息标题" },
                { field: "username", title: "消息类型" },
                { field: "sex", title: "作者" },
                { field: "city", width: 120, title: "发送时间" },
                { field: "sign", title: "发送状态" },              
                {
                  fixed: "right",
                  title: "操作",
                  toolbar: "#barDemo",
                  width: 160
                }
              ]
            ],
            page: true
          });
          element.render();
          form.render();
          table.render();
        });
      });
    },
    add_new(){
      this.$router.push({path:"/Notice/AnewMessage"})
    }

  },
  mounted() {
    // 公共方法
    this.handlePublics();
  },
  updated() {
    // 公共方法
    this.handlePublics();
  }
};
</script>

<style scoped>
.Announcements .layui-form-label {
  width: auto;
}
.Announcements .layui-input-block {
  margin-left: 90px;
}
</style>
